import { Injectable } from '@angular/core';

import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  constructor(private toastr: ToastrService) { }

  showSuccess(message, title = '', time = 5000): void{
    this.toastr.success(message, title, {
      timeOut: time,
      progressBar: true,
      progressAnimation: 'decreasing',
      extendedTimeOut: 2000,
      closeButton: true,
    });
  }

  showError(message, title = '', time = 5000): void{
    this.toastr.error(message, title, {
      timeOut: time,
      progressBar: true,
      progressAnimation: 'decreasing',
      // disableTimeOut: true,
      extendedTimeOut: 2000,
      closeButton: true,
    });
  }

  showInfo(message, title = '', time = 5000): void {
    this.toastr.info(message, title, {
      timeOut: time,
      progressBar: true,
      progressAnimation: 'decreasing',
      extendedTimeOut: 2000,
      closeButton: true,
    });
  }

  showWarning(message, title = '', time = 5000): void {
    this.toastr.warning(message, title, {
      timeOut: time,
      progressBar: true,
      progressAnimation: 'decreasing',
      extendedTimeOut: 2000,
      closeButton: true,
    });
  }

  showData(message, title = ''): void{
    this.toastr.error(message, title, {
      disableTimeOut: true,
      closeButton: true,
      tapToDismiss: false
    });
  }

}
